// Bottom-nav glyphs. Thin stroke, currentColor — inherit active/muted tint
// from the nav button. Shared 24-viewBox so weights line up across the row.
type IconProps = { className?: string };

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function LotsIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base} aria-hidden="true">
      {/* auction gavel: mallet head, handle perpendicular to it, sound block */}
      <rect x="2.5" y="5.5" width="9.5" height="5.2" rx="1.6" transform="rotate(-45 7.25 8.1)" />
      <path d="m9.3 10.2 8 8" strokeWidth={2.4} />
      <rect x="2.5" y="19" width="9.5" height="2.8" rx="1.2" />
    </svg>
  );
}

export function ProfileIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base} aria-hidden="true">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
    </svg>
  );
}

export function WalletIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base} aria-hidden="true">
      <rect x="3" y="6" width="18" height="13" rx="2.5" />
      <path d="M3 10h18" />
      <circle cx="16.5" cy="14.5" r="1.2" />
    </svg>
  );
}

export function InfoIcon({ className }: IconProps) {
  return (
    <svg className={className} {...base} aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11.5v4.5" />
      <path d="M12 8h.01" />
    </svg>
  );
}
